import axios from 'axios/dist/axios';


const medicalStatuses = {
    NONE: "NONE",
    INFORMATION: "INFORMATION",
    URGENT: "URGENT"
};

const defaultState = {
    medicalStatuses: medicalStatuses, // Constants.

    medicalStatus: null,
    assessmentStatus: null,
    urgentData: null,
    mustShowUrgentPopup: false,

    scoringPopupData: null,
    mustShowScoringPopup: false,
    decisionItem: null,
    decisionColor: null,
    decisionColorDark: null,
    decisionIcon: null,
    di1Name: null,
    di2Name: null,
    showIcon: null,
    addInfoIcon: false,
    semiTarget: null
};


// ======================================================================
// Initial State
// ======================================================================

const state = {
    medicalStatuses:      defaultState.medicalStatuses,
    medicalStatus:        defaultState.medicalStatus,
    assessmentStatus:     defaultState.assessmentStatus,
    urgentData:           defaultState.urgentData,
    mustShowUrgentPopup:  defaultState.mustShowUrgentPopup,
    scoringPopupData:     defaultState.scoringPopupData,
    mustShowScoringPopup: defaultState.mustShowScoringPopup,
    decisionItem:         defaultState.decisionItem,
    decisionColor:        defaultState.decisionColor,
    decisionColorDark:    defaultState.decisionColorDark,
    decisionIcon:         defaultState.decisionIcon,
    di1Name:              defaultState.di1Name,
    di2Name:              defaultState.di2Name,
    showIcon:             defaultState.showIcon,
    addInfoIcon:          defaultState.addInfoIcon,
    semiTarget:           defaultState.semiTarget
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getMedicalStatuses: state => state.medicalStatuses,

    getMedicalStatus: state => state.medicalStatus,
    getAssessmentStatus: state => state.assessmentStatus,

    getUrgentData: state => state.urgentData,

    getMustShowUrgentPopup (state)  {
        return state.mustShowUrgentPopup;
    },

    getScoringPopupData: state => state.scoringPopupData,

    getMustShowScoringPopup: state => state.mustShowScoringPopup,
    getDecisionItem: state => state.decisionItem,
    getDecisionColor(state, getters, rootState, rootGetters) {
        const isDarkTheme = rootGetters['ThemeStore/getIsDarkTheme'];
        if (isDarkTheme ) {
            return state.decisionColorDark;
        }
        else {
            return state.decisionColor;
        }
    },
    getDecisionIcon: state => state.decisionIcon,
    getDi1Name: state => state.di1Name,
    getDi2Name: state => state.di2Name,
    getShowIcon: state => state.showIcon,
    getAddInfoIcon: state => state.addInfoIcon,
    getSemiTarget: state => state.semiTarget
};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    refreshAlerts({commit}, data) {
        if (typeof data.assessment === "undefined") {
            return;
        }

        commit("setAssessmentAlertsData", data);

        let mustShowUrgentPopup = (typeof data.assessment.urgentData !== "undefined" && data.assessment.urgentData !== null) ? true : false;

        commit("setMustShowUrgentPopup", mustShowUrgentPopup);

    },

    showScoringPopup({commit}) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/showTAO');

            axiosRequest.then((response) => {

                let taoObject = response.data.data.TAO;
                let decisionItems3 = [];
                let decisionItems4 = [];
                if (taoObject != null && taoObject.decisions != null) {
                    decisionItems3 = taoObject.decisions.decisionItems3 || [];
                    decisionItems4 = taoObject.decisions.decisionItems4 || [];
                }
                // We separate each decisionItems3 and decisionItems4 array into 2 arrays
                // decisionItems3Recommended, decisionItems3Possible, decisionItems4Recommended, decisionItems4Possible
                const {decisionItems3Recommended, decisionItems3Possible, decisionItems4Recommended, decisionItems4Possible} = this._vm.$DecisionItemHelperPlugin.splitDecisionItems(decisionItems3, decisionItems4, 'mandatory');

                // We add the 4 arrays to the TAO object
                taoObject.decisions['decisionItems3Recommended'] = decisionItems3Recommended;
                taoObject.decisions['decisionItems3Possible'] = decisionItems3Possible;
                taoObject.decisions['decisionItems4Recommended'] = decisionItems4Recommended;
                taoObject.decisions['decisionItems4Possible'] = decisionItems4Possible;

                commit('setScoringPopupData', taoObject);

                commit('setMustShowScoringPopup', true);

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    }
};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    setAssessmentAlertsData (state, data) {
        let assessmentData = data.assessment;

        if (typeof assessmentData.medicalStatus !== "undefined") {
            state.medicalStatus = assessmentData.medicalStatus;
        }
        if (typeof assessmentData.assessmentStatus !== "undefined") {
            state.assessmentStatus = assessmentData.assessmentStatus;
        }
        if (typeof assessmentData.urgentData !== "undefined") {
            state.urgentData = assessmentData.urgentData;
        }
        if (assessmentData.decisionItem) {
            state.decisionColor = assessmentData.decisionItem.color;

            if (assessmentData.decisionItem.colorDark != null) {
                state.decisionColorDark = assessmentData.decisionItem.colorDark;
            }
            else {
                state.decisionColorDark = assessmentData.decisionItem.color;
            }

            state.decisionIcon = assessmentData.decisionItem.icon;
            if (assessmentData.decisionItem.di1Name) {
                state.di1Name = assessmentData.decisionItem.di1Name;
            }

            if (assessmentData.decisionItem.di2Name) {
                state.di2Name = assessmentData.decisionItem.di2Name;
            }
            else {
                state.di2Name = null;
            }

            /* if assessmentData.decisionItem !== null && and icon === null ===> display custiom info icon*/
            if (state.decisionIcon === null) {
                state.addInfoIcon = true;
            }
            else {
                state.addInfoIcon = false;
            }
            state.showIcon = true;

        }
        else {
            /*hide any icon if decisionItem === null*/
            state.showIcon = false;
            state.decisionIcon = null;
        }

        if (typeof assessmentData.semiTarget !== "undefined") {
            state.semiTarget = assessmentData.semiTarget;
        }
    },

    setMustShowUrgentPopup (state, data) {
        state.mustShowUrgentPopup = data;
    },

    setScoringPopupData (state, data) {
        state.scoringPopupData = data;
    },
    setMustShowScoringPopup (state, data) {
        state.mustShowScoringPopup = data;
    },


    // ----------------------------------------------------------

    resetStore (state) {
        state.medicalStatuses       = defaultState.medicalStatuses;

        state.medicalStatus         = defaultState.medicalStatus;
        state.assessmentStatus      = defaultState.assessmentStatus;
        state.urgentData            = defaultState.urgentData;
        state.mustShowUrgentPopup   = defaultState.mustShowUrgentPopup;

        state.scoringPopupData      = defaultState.scoringPopupData;
        state.mustShowScoringPopup  = defaultState.mustShowScoringPopup;
        state.decisionItem          = defaultState.decisionItem;
        state.decisionColor         = defaultState.decisionColor;
        state.decisionIcon          = defaultState.decisionIcon;
        state.di1Name               = defaultState.di1Name;
        state.di2Name               = defaultState.di2Name;
        state.showIcon              = defaultState.showIcon;
        state.addInfoIcon           = defaultState.addInfoIcon;
        state.semiTarget            = defaultState.semiTarget;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/AssessmentAlertsStore.js